import {match} from 'ts-pattern';

import type {RowData} from 'features/eag-grid';

const PREDEFINED_COLUMNS = [
  'content',
  'from',
  'to',
  'subject',
  'receivedAt',
  'resource',
  'recordReasoning',
  'customerId',
  'customerReasoning',
  'communicationId',
  'isRead',
] as const;

const READ_STATE_COLUMNS: readonly string[] = ['communicationId', 'isRead'];

// Module level, so the grid gets the same array on every render and does not refetch.
const PREDEFINED_COLUMNS_WITHOUT_READ_STATE = PREDEFINED_COLUMNS.filter(
  (column) => !READ_STATE_COLUMNS.includes(column)
);

// The read column is an ENUM cell; its key stays even though the icon-only cell has no label.
const isUnreadMessageRow = (row: RowData) =>
  match(row.isRead)
    .with({value: {key: 'UNREAD'}}, () => true)
    .otherwise(() => false);

/**
 * Columns and row highlight of the synced-message grids. The read-state columns are requested
 * only with the read state on: a grid that does not know a requested column rejects the whole
 * data request.
 */
export const getSyncedMessagesGridConfig = (isReadStateEnabled: boolean) =>
  isReadStateEnabled
    ? {predefinedColumns: PREDEFINED_COLUMNS, isRowHighlighted: isUnreadMessageRow}
    : {predefinedColumns: PREDEFINED_COLUMNS_WITHOUT_READ_STATE, isRowHighlighted: undefined};
